import styled from "styled-components";

export const Button = styled.button`
  background-color: #3ed598;
  border-radius: 12px;
  text-align: center;
  height: 58px;
  color: white;
  padding: 0 82px;
  border: 0;
`;
